export default {
    owner: 'Titular',
    dependent: 'Dependiente',
    birth: 'Fecha Nac.: ',
    identification: 'Identificación: ',
    age: 'Edad: ',
    sex: 'Sexo:',
    male: 'Masculino',
    female: 'Femenino',
    totalResults: ' Resultados encontrados',
    selectBeneficiary: 'Seleccione un beneficiario',
    updateData: 'Actualizar datos',
    email: {
        textLabel: 'Correo electrónico: ',
        inputLabel: 'Correo electrónico',
        validation: 'Agregue un correo electrónico válido'
    },
    phone: {
        textLabel: 'Teléfono: ',
        inputLabel: 'Teléfono *',
        require: 'Para continuar debe actualizar los datos obligatorios',
        validation: 'Agregue un teléfono válido',
        minLength: 'El teléfono debe contener entre 6 y 15 dígitos.'
    },
    validation: {
        success: 'Datos actualizados con éxito',
        error: 'Ocurrió un error en la actualización de los datos',
        warn: 'Los datos ingresados deben ser válidos'
    },
    notItemsFound: {
        title: 'No se han encontrado coincidencias',
        description: 'Revise los términos utilizados en la búsqueda',
        descriptionPrefix: 'o intente una ',
        descriptionSufix:'nueva búsqueda'
    }
}